import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  getChannelMembers,
  getChannelRowTypingLabel,
} from 'app/shared/components/TeamChat/TeamChat.utils';
import TeamChatChannelTitle from 'app/shared/components/TeamChat/TeamChatChannelTitle';
import PropTypes from 'prop-types';

import { getUuid } from 'store/auth/selectors';
import { selectTeamChatTypingUsers } from 'store/teamChat/selectors';

import HeaderChatInboxRow from '../HeaderChatInboxRow';

const HeaderChatChannelInboxRow = memo(
  ({
    channel,
    chatId,
    actionSlot = null,
    channelName,
    preview = null,
    timestamp = null,
    unread = false,
    unreadCount = 0,
    onSelect,
  }) => {
    const typingUsers = useSelector(selectTeamChatTypingUsers(chatId));
    const currentUserId = useSelector(getUuid);

    const typingLabel = useMemo(
      () =>
        getChannelRowTypingLabel({
          typingUsers,
          members: getChannelMembers(channel),
          currentUserId,
        }),
      [typingUsers, channel, currentUserId],
    );

    const channelNameNode = (
      <TeamChatChannelTitle channel={channel} fallbackName={channelName} isUnread={unread} />
    );

    return (
      <HeaderChatInboxRow
        actionSlot={actionSlot}
        channelName={channelName}
        channelNameNode={channelNameNode}
        dataChatId={chatId}
        preview={preview}
        timestamp={timestamp}
        typingLabel={typingLabel}
        unread={unread}
        unreadCount={unreadCount}
        onSelect={onSelect}
      />
    );
  },
);

HeaderChatChannelInboxRow.propTypes = {
  channel: PropTypes.object.isRequired,
  channelName: PropTypes.string.isRequired,
  chatId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  actionSlot: PropTypes.node,
  preview: PropTypes.string,
  timestamp: PropTypes.string,
  unread: PropTypes.bool,
  unreadCount: PropTypes.number,
};

export default HeaderChatChannelInboxRow;
